if (!customElements.get('collection-sale-filter')) {
  customElements.define('collection-sale-filter', class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('a');
      if (!link) return;
      link.onkeydown = event => {
        if (event.key === ' ') {
          event.preventDefault();
          link.click();
        }
      };
      link.onclick = () => {
        // Liquid supplies the tag path; preserve other filters without retaining pagination.
        const target = new URL(link.href);
        const current = new URL(location.href);
        for (const key of new Set(current.searchParams.keys())) {
          if (key.startsWith('filter.') || key === 'sort_by' || key === 'preview_theme_id' || key === 'view') {
            target.searchParams.delete(key);
            current.searchParams.getAll(key).forEach(value => target.searchParams.append(key, value));
          }
        }
        target.searchParams.delete('page');
        target.searchParams.delete('sale_only');
        link.href = target.toString();
        // The theme's existing data-tag-filter handler performs the single-page update.
      };
    }
  });
}
